const routeURLs = {
	AUTH: '/auth',
	LOGOUT: '/logout',
	SETTINGS: '/settings',
};

export default routeURLs;
